export default function applyLimitSliders(nextButton, prevButton, swiper) {
    if (window.innerWidth > 1000) {
        if (swiper.slides.length < 4 && window.innerWidth > 1220) {
            nextButton.style.display = "none";
            prevButton.style.display = "none";

            return;
        }

        const lastIndex = window.innerWidth > 1220 ? 3 : 2;
        const lastSlide = swiper.slides.length - lastIndex;

        swiper.on('slideChange', function () {
            if (swiper.activeIndex == lastSlide ) {
                swiper.allowSlideNext = false;
                nextButton.classList.add("swiper-button-disabled");
            } else {
                swiper.allowSlideNext = true;

                if (nextButton.classList.contains("swiper-button-disabled")) {
                    nextButton.classList.remove("swiper-button-disabled");
                }
            }
        })
    }
}
